import React, { useEffect } from "react";
import {Button, Form, InputNumber, Tooltip} from "antd";
import { SettingInterface } from "src/store/community/settingsSlice";

import '../Settings.scss';
import { DollarOutlined, QuestionCircleOutlined } from "@ant-design/icons";

interface propsInterface {
  onFinish: Function;
  params?: SettingInterface['data'] | undefined;
}

const _Account = ({ onFinish, params }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      className='v-form v-settings-form'
      layout="vertical"
      autoComplete="off"
      initialValues={params}
    >
      <h6 className="v-content-label o-sm">
        Create defaults

        <Tooltip title="Init coins for new user | guest">
          <QuestionCircleOutlined />
        </Tooltip>
      </h6>

      <Form.Item
        name={['init_coins', 'user']}
        rules={[{ required: true, message: 'Missing value' }]}
      >
        <InputNumber
          addonBefore='user'
          min={0}
          step={5}
          placeholder='5'
          prefix={<DollarOutlined />}
        />
      </Form.Item>

      <Form.Item
        name={['init_coins', 'guest']}
        rules={[{ required: true, message: 'Missing value' }]}
      >
        <InputNumber
          addonBefore='guest'
          min={0}
          step={5}
          placeholder='5'
          prefix={<DollarOutlined />}
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Apply
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _Account;
